const $ = require('jquery');
import _ from "underscore";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import run from '../../utilities/run';
import {validateOnAllSelectChanges} from "../../utilities/select2able";
import render from "../../utilities/render";


// Live form from jsp
run("#return-revamp", ()=>{
  const el = $("#return-revamp");
  returnRevamp(el);

});


function returnRevamp(el){
	 const toOrderPageURL = el.data('to-order-page-url');
	 const toAsnPageURL = el.data('to-asn-page-url');
	 const toRmaPageURL = el.data('to-rma-page-url');
	 const els = {};

	 $(".to-asn-page").on("click", function(){
		window.open(toAsnPageURL);
	 });



	 $(".to-order-page").on("click", function(){
     const url = $(this).closest('.rma-order-row').data('rma-to-order-url');
	   window.open((url) ? url : toOrderPageURL);
	 });

	 $(".to-rma-page").on("click", function(){
		window.open($(this).data("to-rma-page-url"));
	 });



}



// WEBPACK FOOTER //
// ./src/pages/returnRevamp/returnRevamp.js